/* eslint-disable import/no-anonymous-default-export */
import { ENDPOINT } from "../config";
import { fetchFromLawfeed } from "../fetchFromLawfeed";

export default (userId, body) => 
    fetchFromLawfeed(
        { 
            endpoint: ENDPOINT.SIGN_DOC, 
            body, 
            routeParams: [userId] 
        }
    );